function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M31.7063 13.0877H16.3257V19.2792H25.1121C24.7333 21.2805 23.5839 22.9733 21.8513 24.1074C20.3869 25.0663 18.518 25.6334 16.3214 25.6334C12.0686 25.6334 8.47146 22.819 7.18585 19.0374C6.86231 18.0784 6.675 17.0528 6.675 15.9979C6.675 14.9431 6.86231 13.9174 7.18585 12.9584C8.47572 9.18098 12.0729 6.36665 16.3257 6.36665C18.7224 6.36665 20.8722 7.17551 22.5664 8.75987L27.2492 4.16938C24.4183 1.58436 20.7274 0 16.3257 0C9.94439 0 4.42304 3.58567 1.73686 8.81407C0.630039 10.9738 0 13.4171 0 16.0021C0 18.5871 0.630039 21.0262 1.73686 23.1859C4.42304 28.4143 9.94439 32 16.3257 32C20.7359 32 24.431 30.5657 27.13 28.1225C30.2163 25.3373 32 21.2347 32 16.3607C32 15.2266 31.8978 14.1384 31.7063 13.0877Z",
  fill: "#848D9B"
});

var SvgGoogle = function SvgGoogle(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgGoogle, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/google.1252ca59.svg";
export { ForwardRef as ReactComponent };